import { baseApi } from '@/lib/api/baseApi';

import type { Builder } from '../commonApiType/apiBuilderTypes';

export const validateUserTokenApi = baseApi.injectEndpoints({
  endpoints: (builder: Builder) => ({
    validateUser: builder.mutation({
      query: credentials => ({
        url: '/appmanagement/optimize/v1/public/user/validate/user-token',
        method: 'POST',
        body: credentials,
      }),
      transformResponse: response => response,
      invalidatesTags: [{ type: 'Users', id: 'LIST' }],
    }),
  }),
  overrideExisting: 'throw',
});
